// Constants
// Controls
import { FluentProvider } from "@fluentui/react-components";
import { PortalCompatProvider } from "@fluentui/react-portal-compat";
// Utilities
import { getRTL } from "@fluentui/utilities";
import { getV9Theme } from "@ms/planner-models/lib/local/utilities/ThemeUtilities";
import React from "react";
/**
 * Wrapper component that provides the Evo theme to the wrapped component.
 * @param Component to wrap with FluentProvider
 */ export const PlannerThemeProvider = ({ theme, children })=>{
    const v9Theme = getV9Theme(theme);
    return /*#__PURE__*/ React.createElement(FluentProvider, {
        theme: v9Theme,
        dir: getRTL() ? "rtl" : "ltr"
    }, /*#__PURE__*/ React.createElement(PortalCompatProvider, null, children));
};
